<div class="w-full pr-10 flex flex-col gap-4 overflow-hidden">
  <!-- <div class="flex flex-col gap-4 bg-white p-4 rounded-xl">
    <div class="flex gap-2 w-full items-center">
      <img src="../../assets/image/search.svg" alt="" class="" />
      <input placeholder="Search here......" class="w-full border p-2 rounded-md outline-none" />

      <select class="w-80 border p-2 rounded-xl outline-none">
        <option>Report Status</option>
        <option>Success</option>
        <option>Pending</option>
        <option>Refunded</option>
        <option>Reversed</option>
      </select>
    </div>
  </div> -->
  <!-- Input Field -->
  <div class="rounded-md bg-white">
    <!-- <div
      class="border border-transparent border-b-gray-400 border-l-primary w-full"
    >
      <div class="border-[2px] border-l-primary border-transparent h-10"></div>
    </div> -->
    <form [formGroup]="searchForm">
      <div
        class="w-full p-2 grid lg:grid-cols-4 md:grid-col-3 grid-col-1 gap-4 py-3 px-4"
      >
        <div class="flex flex-col gap-2">
          <span>PG REF Number</span>
          <input
            class="w-full outline-none border p-2 rounded-md"
            placeholder="Enter PG REF Number"
            formControlName="PGREFNO"
            maxlength="16"
            (keypress)="keyPressNumbers($event)"
          />
        </div>
        <div class="flex flex-col gap-2">
          <span>Order Id</span>
          <input
            class="w-full outline-none border p-2 rounded-md"
            placeholder="Enter Order Id"
            formControlName="ORDERID"
          />
        </div>
        <div class="flex flex-col gap-2">
          <span>UTR </span>
          <input
            class="w-full outline-none border p-2 rounded-md"
            placeholder="Enter UTR"
            formControlName="UTR"
            maxlength="12"
            (keypress)="keyPressNumbers($event)"
          />
        </div>
        <div class="flex flex-col gap-2">
          <span>Payment Method</span>
          <select
            class="w-full outline-none border p-2 rounded-md"
            formControlName="PAYMENTTYPE"
          >
            <option selected value="">All</option>
            <option value="credit_card">Credit Card</option>
            <option value="debit_card">Debit Card</option>
            <option value="Net_Banking">Net Banking</option>
            <option value="Wallet">Wallet</option>
            <option value="UPI">UPI</option>
            <option value="IMPS">IMPS</option>
          </select>
        </div>
        <div class="flex flex-col gap-2">
          <span>Transaction Type</span>
          <select
            class="w-full outline-none border p-2 rounded-md"
            formControlName="TXNTYPE"
          >
            <option selected value="">All</option>

            <option value="Sale">Sale</option>
            <option value="Refund">Refund</option>
            <option value="Check">Check</option>
          </select>
        </div>
        <div class="flex flex-col gap-2">
          <span>Status</span>
          <select
            class="w-full outline-none border p-2 rounded-md"
            formControlName="STATUS"
          >
            <option selected value="">All</option>

            <option value="Captured">Captured</option>
            <option value="Settled">Settled</option>
            <option value="Failed">Failed</option>
            <option value="Cancelled">Cancelled</option>
            <option value="Pending">Pending</option>
            <option value="Invalid">Invalid</option>
          </select>
        </div>

        <div class="flex flex-col gap-2">
          <span>Customer Email</span>
          <input
            class="w-full outline-none border p-2 rounded-md"
            placeholder="Enter Customer Email"
            formControlName="CUSTOMEREMAIL"
          />
        </div>
        <div class="flex flex-col gap-2">
          <span>Merchant</span>
          <select
            class="w-full outline-none border p-2 rounded-md"
            formControlName="MERCHANTID"
          >
            <option selected value="">All</option>

            <option *ngFor="let item of merchantList" value="{{ item?._id }}">
              {{ item?.name }}
            </option>
          </select>
        </div>
        <div class="flex flex-col gap-2">
          <span>Date From :</span>
          <input
            type="date"
            class="w-full outline-none border p-2 rounded-md"
            [max]="cValue"
            formControlName="STARTDATE"
          />
        </div>
        <div class="flex flex-col gap-2">
          <span>Date To :</span>
          <input
            type="date"
            class="w-full outline-none border p-2 rounded-md"
            [min]="searchForm.controls['STARTDATE'].value"
            formControlName="ENDDATE"
          />
        </div>

        <div class="flex flex-col gap-2">
          <span>Payment Mode</span>
          <select
            class="w-full outline-none border p-2 rounded-md"
            formControlName="MOPTYPE"
          >
            <option selected value="">All</option>
            <option value="Visa">Visa</option>
            <option value="master_card">Master Card</option>
            <option value="Rupay">Rupay</option>
            <option value="UPI">UPI</option>
            <option value="IMPS">IMPS</option>
            
          </select>
        </div>

        <div class="flex flex-col gap-2">
          <span>Acquirer :</span>
          <select
            class="w-full outline-none border p-2 rounded-md"
            placeholder="Enter Currency"
            formControlName="ACQID"
          >
            <option selected value="">All</option>
            <option *ngFor="let item of provider" value="{{ item?._id }}">
              {{ item?.providerName | titlecase }}
            </option>
          </select>
        </div>
      </div>
    </form>
    <div class="flex justify-end gap-4 p-2">
      <app-primary-button (click)="getPaymentListing(pagination)"
        >Search</app-primary-button
      >
      <!-- <app-primary-button>View</app-primary-button>
      <app-primary-button>Download</app-primary-button> -->
    </div>
  </div>
  <!-- ************************** Table Data *************************** -->

  <div class="w-full flex flex-col gap-2">
    <div class="flex gap-4 justify-end px-2">
      <!-- <app-primary-button>Copy</app-primary-button> -->
      <app-primary-button (click)="exportCSV()">Export</app-primary-button>
      <!-- <app-primary-button>PDF</app-primary-button> -->
    </div>
    <div
      class="w-full bg-white p-4 rounded-xl flex flex-col px-4 overflow-auto"
    >
      <table class="w-[100%] text-left h-full overflow-auto">
        <tr class="h-8">
          <th class="px-4 mx-5 text-nowrap">Order Id</th>
          <th class="px-4 mx-5 text-nowrap">UTR</th>
          <th class="px-4 mx-5 text-nowrap">Pg Ref Num</th>
          <th class="px-4 mx-5 text-nowrap">Merchant</th>
          <th class="px-4 mx-5 text-nowrap">Mobile</th>
          <th class="px-4 mx-5 text-nowrap">Email</th>
          <th class="px-4 mx-5 text-nowrap">Date & Time</th>
          <th class="px-4 mx-5 text-nowrap">Txn Type</th>
          <th class="px-4 mx-5 text-nowrap">Mop Type</th>
          <th class="px-4 mx-5 text-nowrap">Payment Method</th>

          <th class="px-4 mx-5 text-nowrap">Status</th>
          <th class="px-4 mx-5 text-nowrap">Base Amount</th>
        </tr>
        <tr
          *ngFor="let item of paymentList; let i = index"
          class="h-8 text-left"
          [ngStyle]="{
            backgroundColor:
              i % 2 == 0
                ? 'color-mix(in oklch,var(--primary) 10%,transparent)'
                : 'white'
          }"
        >
          <td class="px-4 mx-5 text-nowrap">
            {{ item.ORDERID ? item.ORDERID : "-" }}
          </td>
          <td class="px-4 mx-5 text-nowrap">
            {{ item.UTR ? item.UTR : "-" }}
          </td>
          <td class="px-4 mx-5 text-nowrap">
            {{ item.PGREFNO ? item.PGREFNO : "-" }}
          </td>
          <td class="px-4 mx-5 text-nowrap">
            {{ item.MERCHANTNAME ? item.MERCHANTNAME : "-" }}
          </td>
          <td class="px-4 mx-5 text-nowrap">
            {{ item.MOBILENO ? item.MOBILENO : "-" }}
          </td>
          <td class="px-4 mx-5 text-nowrap">
            {{ item.CUSTOMEREMAIL ? item.CUSTOMEREMAIL : "-" }}
          </td>
          <td class="px-4 mx-5 text-nowrap">
            {{
              item.CREATEDAT
                ? (item.CREATEDAT | date : "medium" : "+0000")
                : "-"
            }}
          </td>

          <td class="px-4 mx-5 text-nowrap">
            {{ item.MODEL ? item.MODEL : "-" }}
          </td>
          <td class="px-4 mx-5 text-nowrap">
            {{ item.MOPTYPE ? item.MOPTYPE : "-" }}
          </td>
          <td class="px-4 mx-5 text-nowrap">
            {{ item.TXNTYPE ? item.TXNTYPE : "-" }}
          </td>
          <td class="px-4 mx-5 text-nowrap">
            {{ item.STATUS ? item.STATUS : "-" }}
          </td>
          <td class="px-4 mx-5 text-nowrap">
            {{ item.AMOUNT ? item.AMOUNT.toFixed(2) : "-" }}
          </td>
        </tr>
      </table>
    </div>
    <app-empty-data
      *ngIf="paymentList?.length < 1"
      class="justify-center align-items-center"
      [imageSource]="'../../assets/blankScreen/service_request.png'"
      [message]="'No data available'"
    ></app-empty-data>
    <app-next-preview-button
      [limit]="paginationLimit"
      [currentPage]="paginationCurrentPage"
      [totalRecords]="paginationTotalData"
      [totalPage]="paginationTotalPage"
      (next)="nextPage()"
      (previous)="previousPage()"
      (pageChange)="onPageChange($event)"
      (last)="onLast()"
      (first)="onFirst()"
    ></app-next-preview-button>
  </div>
</div>
